export default "__VITE_ASSET__86388d32__"